import { render } from "./MembersFooter.vue?vue&type=template&id=3cd41965&scoped=true"
import script from "./MembersFooter.vue?vue&type=script&lang=js"
export * from "./MembersFooter.vue?vue&type=script&lang=js"

import "./MembersFooter.vue?vue&type=style&index=0&id=3cd41965&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd41965"]])

export default __exports__